import React from "react";
import {Spinner} from "peggirkit";

const LoadingScreen = () => {
    return (
        <div className={"w-full h-full flex items-center justify-center p-3"}>
            <Spinner size={"lg"}/>
        </div>
    );
};

export default LoadingScreen;